'use strict';

var icon = require('../../../../../../../../../../_virtual/icon2.cjs');

(function (exports) {

	exports.ICON_AVIARY_SIZES = void 0;
	(function(ICON_AVIARY_SIZES) {
	    ICON_AVIARY_SIZES["xsmall"] = "xsmall";
	    ICON_AVIARY_SIZES["small"] = "small";
	    ICON_AVIARY_SIZES["medium"] = "medium";
	    ICON_AVIARY_SIZES["large"] = "large";
	})(exports.ICON_AVIARY_SIZES || (exports.ICON_AVIARY_SIZES = {}));
	const ICON_PIXEL_DIMENSIONS = {
	    xsmall: {
	        height: 32,
	        width: 32
	    },
	    small: {
	        height: 40,
	        width: 40
	    },
	    medium: {
	        height: 48,
	        width: 48
	    },
	    large: {
	        height: 64,
	        width: 64
	    }
	};

	exports.ICON_PIXEL_DIMENSIONS = ICON_PIXEL_DIMENSIONS;
	
} (icon.__exports));
//# sourceMappingURL=icon.cjs.map
